import { useMemo } from 'react';
import { TRegInStorage, TRegistration } from '../types';
import moment from 'moment';

interface IArgs {
  search: string;
  totalRegistrations: (TRegistration | TRegInStorage)[];
  sortBy: string;
  debouncedSearch: string;
}

const useSortRegistrations = ({ debouncedSearch, search, sortBy, totalRegistrations }: IArgs) => {
  const sortedRegistrations = useMemo(() => {
    if (search) {
      totalRegistrations = totalRegistrations.filter((reg) =>
        reg?.businessNameOptions?.[0]?.toLowerCase().includes(debouncedSearch?.toLowerCase()),
      );
    }
    if (sortBy === 'BusinessNameOptions[0]') {
      totalRegistrations.sort((a, b) =>
        (a?.businessNameOptions?.[0] ?? '') > (b?.businessNameOptions?.[0] ?? '')
          ? 1
          : (a?.businessNameOptions?.[0] ?? '') < (b?.businessNameOptions?.[0] ?? '')
          ? -1
          : 0,
      );
    } else if (sortBy === 'createdAt') {
      totalRegistrations.sort((a, b) =>
        (a?.createdAt ?? '') > (b?.createdAt ?? '')
          ? -1
          : (a?.createdAt ?? '') < (b?.createdAt ?? '')
          ? 1
          : 0,
      ); //reverse order newest to oldest
    } else if (sortBy === 'completedBy') {
      totalRegistrations.sort((a, b) =>
        moment(a?.createdAt).add(15, 'days') > moment(b?.createdAt).add(15, 'days')
          ? -1
          : moment(a?.createdAt).add(15, 'days') < moment(b?.createdAt).add(15, 'days')
          ? 1 //reverse order newest to oldest
          : 0,
      );
    }

    return totalRegistrations;
  }, [sortBy, debouncedSearch, totalRegistrations]);

  return { sortedRegistrations };
};

export default useSortRegistrations;
